import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import { withStyles, MuiThemeProvider, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";

import { Typography, Grid } from '@material-ui/core';

import { AppState, Actions, store, IPageState } from '../../appredux'
import CONFIG from '../../cfg/config';
import { MenuService, AsortMenuWiersz, AsortGrupyWiersz, Font, AsortWWWMenuNagl } from '../../api';

import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import { TableRow } from '@material-ui/core';
import Button from '@material-ui/core/Button';

import { AddItem } from '../PanelRightBasket';
import DialogChangeItem from '../dialog/ChangeItem';
import themeDialog from '../../themes-dialog';
import { fontSelect } from '../../fonts';
import { dostepnePrioryety, sendErrorLog } from '../common/helpers';

import './ZamowienieAnimacjaTekstu.css'

//PM 2021-03-11
//wstrzykniecie tylko uzywanych pol z magazynu danych
type ZamowienieProps = {
  page: IPageState,
  windowWidth: number,
}

type ZamowienieState = {
  headerIds: number[],
  headers: (AsortMenuWiersz & { kolor?: boolean })[],
  openChange: boolean,
  item: AsortGrupyWiersz,
  reload: number,
  koszyk: AsortGrupyWiersz[]
}

class Zamowienie extends React.Component<ZamowienieProps & WithStyles<typeof styles>, ZamowienieState> {
  textTheme = fontSelect(this.props.page.fonts, 7, 1) as React.CSSProperties;
  contentTheme = fontSelect(this.props.page.fonts, 8, 2) as React.CSSProperties;

  constructor(props: ZamowienieProps & WithStyles<typeof styles>) {
    super(props, {});
    //this.getData();
    this.state = {
      headerIds: [],
      headers: [],
      openChange: false,
      item: new AsortGrupyWiersz(),
      reload: 0,
      koszyk: []
    };
  }

  componentDidMount() {
    this.getData();
  }

  //PM 2021-03-11
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  componentDidUpdate(prevProps: ZamowienieProps) {
    if (prevProps.page.menuItems !== this.props.page.menuItems) {
      this.getData();
    }
    if (prevProps.page.selectedMenuItem !== this.props.page.selectedMenuItem) {
      this.getData();
    }
    if(prevProps.page.resetBoldy !== this.props.page.resetBoldy || this.props.page.basket.length === 0 && prevProps.page.basket.length !== 0){
      this.resetKoszyk()
    }
  }

  resetKoszyk = () => {
    this.setState({koszyk: []})
    store.dispatch(Actions.pageState.setAsortymentowWGrupie(0));
    store.dispatch(Actions.pageState.setPriorytet(this.props.page.priorytetMin))
  }

  //PM 2021-11-03
  //if (this.props.asort[i] && this.props.asort[i][0] && this.props.asort[i][0].grupa_id && this.props.asort[i][0].grupa_id === e)
  //await
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  getData = () => {
    let id = this.props.page.selectedMenuItem; //menu_id
    let data = this.props.page.asortHeaders.filter((e) => e.menu_id === id)
    let ids: number[] = [];
    data.forEach((e) => { ids.push(e.grupa_id) }); //wszystkie id z grupy z menu
    this.setState({ headerIds: ids, headers: data });

    let load = true;
    ids.forEach(async (e) => {
      load = true;
      for (let i = 0; i < this.props.page.asort.length; i++) {
        if (this.props.page.asort[i] && this.props.page.asort[i][0] && this.props.page.asort[i][0].grupa_id && this.props.page.asort[i][0].grupa_id === e && this.props.page.asort[i][0].menu_id === id   ) {
          load = false;
          break;
        }
      }
      if (load) {
        await this.getAsortData(e, id)
      }
    });
  };

  //PM 2021-09-01
  //console.error -> console.log()
  async getAsortData(id: number, menu_id: number) {
    try {
      const res = await MenuService.getAsort({ hotelId: CONFIG.hotelID, aOperatorId: Number(sessionStorage.getItem("operator_id")), aGrupaId: id }, {})
      let priorytet = this.props.page.asortHeaders.find((e) => e.grupa_id === id && e.menu_id === menu_id)?.priorytet
      //console.log(this.props.page.asortHeaders)
      if(priorytet){
        res.result = res.result.map(x => ({...x, priorytet: Number(priorytet)}))
      }
      res.result = res.result.map(x => ({...x, menu_id: Number(menu_id)}))
      
      //////////////////////////////////////////////////////
      //console.log(id)
      // if(id === 2){ //dania z drobiu
      //   res.result = res.result.map(x => ({...x, priorytet: 1}))
      // } else if(id === 3){ //surówki
      //   res.result = res.result.map(x => ({...x, priorytet: 2}))
      // } else if(id === 15){ //dodatki
      //   res.result = res.result.map(x => ({...x, priorytet: 3}))
      // } else {
      //   res.result = res.result.map(x => ({...x, priorytet: 0}))
      // }
      //console.log(res.result)
      //console.log(res.result[0].priorytet)
      //////////////////////////////////////////////////////

      await store.dispatch(Actions.pageState.getAsort(res.result));
    } catch (err) {
      console.log(err)
      await sendErrorLog("0", "-1", '/manager/dajAsortWwwGrupyWiersz')
      await store.dispatch(Actions.pageState.addFcmLogMessage("/manager/dajAsortWwwGrupyWiersz", 2))
    }
  }

  //PM 2021-03-11
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  addItemFunc = async (row: AsortGrupyWiersz) => {
    //console.log(row)
    if(row.tag_06 === "1" || row.tag_07 === "1" || row.tag_08 === "1" || row.tag_11 === "1" || row.tag_12 === "1" || row.tag_13 === "1"){

    } else {

      if (row.nazwa_do_zm === 1) {
        this.setState({ openChange: true, item: row })
      } else {
        const menuItem = this.props.page.menuItems.find(e => e.menu_id === this.props.page.selectedMenuItem)
  
        if (menuItem)
          if (this.props.page.minItems < menuItem.zamowienie_min_ilosc_pozycji) {
            await store.dispatch(Actions.pageState.setMinItems(menuItem.zamowienie_min_ilosc_pozycji));
          }
  
        await AddItem(row);

        this.setState({ koszyk: [...this.state.koszyk, row] })  
        this.zmienPriorytet(row.priorytet)
        store.dispatch(Actions.pageState.setAsortymentowWGrupie(1));
      }

    }
    
  }

  zmienPriorytet = (asortPriorytet: number) => {
    let p = this.props.page.priorytet
    let next = this.props.page.priorytet

    
    let priorytety = dostepnePrioryety(this.props.page.asortHeaders, this.props.page.selectedMenuItem)


    priorytety.forEach((x, index) => {
      if(asortPriorytet === x){
        if(priorytety.length > index + 1){
          next = priorytety[index + 1]
          //console.log(next, "1")
        } //else {
          //next = priorytety[0]
          //console.log(next, "2")
        //}
      }
    })

    



    //if(p === 1){ next = 2 }
    //else if(p === 2){ next = 3 } 
    //else if(p === 3){ next = 1 } 


    if(asortPriorytet !== 0){
      store.dispatch(Actions.pageState.setPriorytet(next))
    }
    
  }

  closeDialogChangeItem = () => {
    this.setState({ openChange: false })
  }

  //PM 2021-03-17
  checkUndefined = (asort: AsortGrupyWiersz[][]) => {
    if (asort.length <= 0) return false;

    let value = true;

    asort.forEach(x => {
      if (x == undefined) {
        value = false;
      }
    });

    return value;
  }

  animmacjaDodania = (danie: AsortGrupyWiersz) => {
    let cell = document.getElementById(danie.asort_nazwa)

    if (cell) {

      let parent = cell.parentElement
      let imgAnimation = cell.cloneNode(false) as HTMLElement

      let ostatniaAnimacja = parent?.lastChild as HTMLElement
      if (ostatniaAnimacja.classList.toString().includes("animationText")) {
        parent?.removeChild(ostatniaAnimacja)
      }

      cell.innerText = ""

      imgAnimation.classList.add("animationText");
      imgAnimation.style.fontWeight = "bold"
      imgAnimation.style.position = "absolute"
      imgAnimation.style.left = "0px"
      imgAnimation.innerText = danie.asort_nazwa

      parent?.appendChild(imgAnimation)

      setTimeout(() => {
        try {
          parent?.removeChild(imgAnimation)
          cell!.innerText = danie.asort_nazwa
        } catch (error) {
        }
      }, 2000);

    }

  }

  animmacjaDodaniaJedenElement = (danie: AsortGrupyWiersz) => {
    let cell = document.getElementById(danie.asort_nazwa)

    if(cell && !(cell.classList.toString().includes("animationText")) ){

      cell.classList.remove("animationText");
      cell.style.fontWeight = "normal"
      cell.style.position = "inherit"

      cell.classList.add("animationText");
      cell.style.fontWeight = "bold"
      cell.style.position = "absolute"
   
      setTimeout(() => {
        cell!.classList.remove("animationText");
        cell!.style.fontWeight = "normal"
        cell!.style.position = "inherit"
      }, 2000);

    }
    
  }

  //PM 2021-03-11
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  render() {
    const classes = this.props.classes;
    const header = this.state.headers;
    let data: AsortGrupyWiersz[][] = [];
    let asort: AsortGrupyWiersz[][] = [];
    let half = header.length % 2 === 0 ? header.length / 2 : header.length / 2 + 1;
    let lengthAll = 0;
    let lengthHalf = 0;
    let kol = true;

    //console.log(this.props.page.priorytet, this.props.page.priorytetMin, this.props.page.priorytetMax)
    //console.log(this.props.page.asort)
    //console.log(this.props.page.asortymentowWGrupie)


    header.forEach(e => {
      data = this.props.page.asort.filter(el => el[0] && el[0].grupa_id === e.grupa_id && el[0].menu_id === e.menu_id); ///////////////////////
      asort.push(data[0] ? data[0] : []);
      //vscTest
      //console.log(e.grupa_opis, data)
    })
    //console.log(asort)

    //////////////////////////////////////////////////////////////////////////////////
    // header.forEach((e, index) => {
    //   kolor = true;

    //   //this.props.page.basket.forEach((b) => {
    //   this.state.koszyk.forEach((b) => {
    //     if (Number(b.grupa_id) === e.grupa_id)
    //       kolor = false;
    //   })
    //   e.kolor = kolor;
    // })
    //////////////////////////////////////////////////////////////////////////////////

    //console.log(asort)

    let isSafe = true
    asort.forEach(x =>{
      if(x){
       } else {
        isSafe = false
      }
    })

    if(isSafe){

      asort.forEach((x, indexX)  => {
        x.forEach((y, indexY) =>{
          kol = true;
  
          this.state.koszyk.forEach((b) => {
            if (asort[indexX][indexY].priorytet === this.props.page.priorytetMax && b.asort_id === asort[indexX][indexY].asort_id) {
              kol = false;
            } else if (asort[indexX][indexY].priorytet !== this.props.page.priorytetMax && b.grupa_id === asort[indexX][indexY].grupa_id) {
              kol = false;
            }
          })
    
          asort[indexX][indexY].bold = kol
          
        })
      })

    }
    
    
    
    //////////////////////////////////////////////////////////////////////////////////

    //vscTest
    //console.log(asort)

    if (this.checkUndefined(asort) && header.length % 2 === 1) {
      lengthAll = asort.flat().length

      for (let i = 0; i < asort.length / 2 - 1; i++) {
        lengthHalf += asort[i].length
      }
      if (lengthHalf * 2 >= lengthAll) {
        half = header.length / 2
      }
    }

    const header1 = header.slice(0, half);
    const header2 = header.slice(half);
    const asort1 = asort.slice(0, half);
    const asort2 = asort.slice(half);

    let selectedMenuItem = this.props.page.menuItems.find(x => x.menu_id === this.props.page.selectedMenuItem)
    
    //vscTest

    //row.priorytet === this.props.page.priorytet || this.props.page.priorytet === this.props.page.priorytetMin && row.priorytet === this.props.page.priorytetMax

    return (
      <>
        <Grid item xs={12} md={6} style={{ paddingRight: this.props.windowWidth > 600 ? "20px" : "0px", marginTop: "-1.2em" }}>
          {asort1.length && asort1[0] !== undefined ? header1.map((tab, index) => (
            <React.Fragment key={tab.grupa_id}>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell style={{ ...this.textTheme, paddingBottom: asort1[index] && asort1[index][0] && asort1[index][0].asort_nazwa.includes("|") ? "10px" : "5px" }}>{tab.grupa_opis}</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {asort1[index] ? asort1[index].map((row) => (
                    <TableRow key={tab.grupa_opis + row.asort_nazwa} style={{height: "25px", position: "relative"}}>
                      <TableCell onClick={async () => { if(( row.priorytet === this.props.page.priorytet )){ await this.addItemFunc(row); this.animmacjaDodania(row)}else{} }} 
                       id={row.asort_nazwa} style={{ ...this.contentTheme, paddingBottom: row.asort_nazwa.includes("|") ? "5px" : "inherit", fontWeight: row.bold ? "bold" : "normal", lineHeight: "25px", 
                       cursor: row.priorytet === this.props.page.priorytet ? "pointer" : "default", 
                       color: row.priorytet === this.props.page.priorytet ? this.contentTheme.color : "gray" }} align="left">
                        {row.asort_nazwa.includes("|") ?
                          <Fragment> <span>{row.asort_nazwa.split("|")[0]}</span><br /><span style={{ fontWeight: "normal", paddingBottom: "5px" }}>{row.asort_nazwa.split("|")[1]}</span>  </Fragment>
                          : row.asort_nazwa}
                      </TableCell>
                      <TableCell style={{ ...this.contentTheme, fontWeight: "normal", color: row.priorytet === this.props.page.priorytet ? this.contentTheme.color : "gray" }} align="right">{row.cena}</TableCell>
                      <TableCell align="right" style={{ width: "25px" }}>
                      {row.tag_06 === "1" || row.tag_07 === "1" || row.tag_08 === "1" || row.tag_11 === "1" || row.tag_12 === "1" || row.tag_13 === "1" ?
                        null :
                        <Button disabled={ !(row.priorytet === this.props.page.priorytet ) } className={classes.add} classes={{ "label": this.props.windowWidth > 600 ? classes.label : classes.labelPhone }}
                          onClick={async () => { await this.addItemFunc(row); this.animmacjaDodania(row) }}><span style={{ fontSize: "16px" }}>+</span></Button>}
                      </TableCell>
                    </TableRow>
                  )) : null}
                </TableBody>
              </Table>
              <hr className={classes.hr} />
            </React.Fragment>
          ))
            :
            (
              <Typography variant="h6" component="h2" color="primary" style={{ padding: "20px", fontSize: "14px" }}>
                <b>Ładowanie...</b>
              </Typography>
            )}
        </Grid>
        <Grid item xs={12} md={6} style={{ paddingRight: this.props.windowWidth > 600 ? "20px" : "0px", marginTop: "-1.2em", position: "relative" }}>
          {asort2.length ? header2.map((tab, index) => (
            <React.Fragment key={tab.grupa_id}>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.head} style={{ ...this.textTheme, paddingBottom: asort2[index] && asort2[index][0] && asort2[index][0].asort_nazwa.includes("|") ? "10px" : "5px" }}>{tab.grupa_opis}</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {asort2[index] ? asort2[index].map((row) => (
                    <TableRow key={tab.grupa_opis + row.asort_nazwa} style={{height: "25px", position: "relative"}}>
                      <TableCell onClick={async () => { if((row.priorytet === this.props.page.priorytet )){ await this.addItemFunc(row); this.animmacjaDodania(row)}else{} }} 
                      id={row.asort_nazwa} style={{ ...this.contentTheme, paddingBottom: row.asort_nazwa.includes("|") ? "5px" : "inherit", fontWeight: row.bold ? "bold" : "normal", lineHeight: "25px", 
                      cursor: row.priorytet === this.props.page.priorytet ? "pointer" : "default",
                      color:  row.priorytet === this.props.page.priorytet ? this.contentTheme.color : "gray" }} align="left">
                        {row.asort_nazwa.includes("|") ?
                          <Fragment> <span>{row.asort_nazwa.split("|")[0]}</span><br /><span style={{ fontWeight: "normal", paddingBottom: "5px" }}>{row.asort_nazwa.split("|")[1]}</span>  </Fragment>
                          : row.asort_nazwa}
                      </TableCell>
                      <TableCell style={{ ...this.contentTheme, fontWeight: "normal", color: row.priorytet === this.props.page.priorytet ? this.contentTheme.color : "gray" }} align="right">{row.cena}</TableCell>
                      <TableCell align="right" style={{ width: "25px" }}>
                        {row.tag_06 === "1" || row.tag_07 === "1" || row.tag_08 === "1" || row.tag_11 === "1" || row.tag_12 === "1" || row.tag_13 === "1" ?
                        null : 
                        <Button disabled={ !(row.priorytet === this.props.page.priorytet ) } className={classes.add} classes={{ "label": this.props.windowWidth > 600 ? classes.label : classes.labelPhone }}
                          onClick={async () => { await this.addItemFunc(row); this.animmacjaDodania(row) }}><span style={{ fontSize: "16px" }}>+</span></Button>}
                      </TableCell>
                    </TableRow>
                  )) : null}
                </TableBody>
              </Table>
              <hr className={classes.hr} style={{marginBottom: index === header2.length -1 ? "15px" : "0.5em"}} />
            </React.Fragment>
          ))
            : null}

          {selectedMenuItem && selectedMenuItem.zamowienie_min_ilosc_pozycji > 1 && this.props.page.asortymentowWGrupie >= selectedMenuItem.zamowienie_min_ilosc_pozycji ?
            <Button variant='contained' color='secondary' style={{  }} className={classes.buttonAgin} onClick={this.resetKoszyk}>{"powtórz"}</Button>
            : selectedMenuItem && selectedMenuItem.zamowienie_min_ilosc_pozycji > 1 && this.props.page.asortymentowWGrupie < selectedMenuItem.zamowienie_min_ilosc_pozycji ?
            <Button variant='text' style={{ color: this.textTheme.color }} className={classes.buttonAgin} onClick={() => { }}>{"min ilość: " + selectedMenuItem.zamowienie_min_ilosc_pozycji}</Button>
            : null}
        
        </Grid>
        {this.state.openChange ?
          <MuiThemeProvider theme={themeDialog}>
            <DialogChangeItem item={this.state.item} open={this.state.openChange} close={this.closeDialogChangeItem} />
          </MuiThemeProvider> : null}
      </>
    )
  }
}

const styles = (theme: Theme) => ({
  add: {
    padding: "0",
    minWidth: "25px",
    width: "25px",
    height: "25.6px",
    border: "1px solid #aaa",
    //borderRadius: "0"
  },
  hr: {
    border: "0",
    borderBottom: "1px solid #ddd",
  },
  table: {
    marginTop: "1.2em",
    marginBottom: "1.2em"
  },
  label: {
    marginTop: "-4px"
  },
  labelPhone: {
    marginTop: "0px"
  },
  head: {
    paddingBottom: "5px"
  }, 
  buttonAgin: {
    //position: "absolute" as "absolute", 
    //right: "30px", 
    //bottom: "-10px",
    float: "right" as "right",
    paddingBottom: "8px",
    marginRight: "10px",
    //padding: 0,
    //borderRadius: "0",
    borderColor: "lavender",
    fontSize: '11px',
    fontWeight: "bold" as "bold",
    lineHeight: '1.5',
    letterSpacing: '0.00938em',
    textTransform: 'none' as 'none',
    //minWidth: 170,

    //"&:hover": {
    //    background: 'none'
    //}
},

});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState,
});

export default connect(mapStateToProps)(withStyles(styles)(Zamowienie));